import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

import { Component, DestroyRef, inject, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "app-auth-layout",
  templateUrl: "./auth-layout.component.html",
  styleUrls: ["./auth-layout.component.scss"],
})
export class AuthLayoutComponent implements OnInit, OnDestroy {
  private destroyRef = inject(DestroyRef);

  public isCollapsed = true;

  constructor(private router: Router) {}

  ngOnInit() {
    const html = document.getElementsByTagName("html")[0];
    html.classList.add("auth-layout");
    const body = document.getElementsByTagName("body")[0];
    body.classList.add("bg-default");
    this.router.events.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((event) => {
      this.isCollapsed = true;
    });
  }

  ngOnDestroy() {
    const html = document.getElementsByTagName("html")[0];
    html.classList.remove("auth-layout");
    const body = document.getElementsByTagName("body")[0];
    body.classList.remove("bg-default");
  }
}
